/**
 * Display helpers for module completion status (no React / API).
 */

export const MODULE_STATUS = {
  COMPLETED: 'Completed',
  ONGOING: 'Ongoing',
};

export function statusLabel(status) {
  if (status === MODULE_STATUS.COMPLETED || status === true) return MODULE_STATUS.COMPLETED;
  return MODULE_STATUS.ONGOING;
}

export function isCompletedStatus(status) {
  return statusLabel(status) === MODULE_STATUS.COMPLETED;
}

export function formatCompletionRate(summary) {
  if (!summary) return '0%';
  return summary.completionRate || '0%';
}

export function studentProgressCell(student, moduleId) {
  return student?.progressByModule?.[moduleId] || {
    status: MODULE_STATUS.ONGOING,
    isCompleted: false,
  };
}
